import { render, staticRenderFns } from "./specialistMemberList.vue?vue&type=template&id=670e04a6&"
import script from "./specialistMemberList.vue?vue&type=script&lang=js&"
export * from "./specialistMemberList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports